import React from 'react';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
export function BeforeAfterPage() {
  return <div className="pt-28" data-id="element-764">
      <BeforeAfterSection data-id="element-765" />
    </div>;
}